import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material";


export default function TextCardBold({ textcard, color }) {

    const theme = useTheme();
   
    return (

        theme.palette.mode === "light" ? (
               
          <Typography variant="subtitle2" color= 'common.black' fontWeight={600}>
              {textcard} 
          </Typography>

        ) : (

        <Typography variant="subtitle2" color= 'common.white' fontWeight={600}>
            {textcard} 
        </Typography>

        )

 );
}